import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  userType?: string;
  exp?: number;
}

/**
 * Persist the auth token and derive the user's role from the JWT so that every
 * login path (password, OTP, password-reset) stores a consistent `role`.
 */
export const persistAuth = (token: string): string | null => {
  localStorage.setItem("token", token);
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    if (decoded?.userType) {
      localStorage.setItem("role", decoded.userType);
      return decoded.userType;
    }
  } catch {
    // Undecodable token: leave role unset rather than crashing.
  }
  localStorage.removeItem("role");
  return null;
};

/** Remove all auth state. Used on logout and token expiry. */
export const clearAuth = (): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
};
